import Link from 'next/link';
import React from 'react';

/* Hints to web crawlers that we DO NOT want them to follow these links or share our precious page authority with them
 * Web crawlers do not have to obey rel='nofollow', but they promise to consider it
 *
 * Please use this component for links leading to the main Shef site to ensure we always include rel='nofollow'
 */
export const NoFollowLink: React.FC<React.ComponentProps<typeof Link>> = (props) => {
  const { children } = props;
  return (
    <Link className='hover:text-kale-400' rel='nofollow' {...props}>
      {children}
    </Link>
  );
};
